/* 87C custom — cf snippets/_87c-customs-index.liquid */
/**
 * 87C Scroll Reveal — IntersectionObserver for entrance animations.
 *
 * Targets both Reformation native elements and 87C custom elements.
 * Only hides below-fold elements (above-fold stay visible — no flash).
 * Skips elements already animated by CSS @keyframes (first-4 cards).
 * Adds stagger delays for grid items revealed in the same batch.
 */
(function () {
	'use strict';

	var CARD_SELECTORS = [
		'.product-card',
		'.c87-card',
		'.collection-card',
		'.collection-list-item'
	].join(', ');

	var SECTION_SELECTORS = [
		'.featured-collection',
		'.collection-list',
		'.text-with-icons',
		'.gallery',
		'.image-banner',
		'.rich-text',
		'.multicolumn',
		'.video-section'
	].join(', ');

	var ALL_SELECTORS = CARD_SELECTORS + ', ' + SECTION_SELECTORS;

	var THRESHOLD = 0.06;
	var ROOT_MARGIN = '0px 0px -60px 0px';

	if (!('IntersectionObserver' in window)) {
		return;
	}

	function isAboveFold(el) {
		var rect = el.getBoundingClientRect();
		return rect.top < window.innerHeight * 1.1;
	}

	function hasCSSkeyframes(el) {
		/* Skip elements already targeted by CSS @keyframes c87-fade-up
		   (first 4 children of grids) to avoid double animation. */
		try {
			var anim = window.getComputedStyle(el).animationName;
			return anim && anim !== 'none';
		} catch (e) {
			return false;
		}
	}

	function isCardSelector(el) {
		return el.matches(CARD_SELECTORS);
	}

	function assignStagger(el) {
		if (!isCardSelector(el)) return;
		var parent = el.parentElement;
		if (!parent) return;
		var siblings = parent.querySelectorAll('.c87-reveal:not([data-revealed])');
		for (var i = 0; i < siblings.length && i < 5; i++) {
			if (siblings[i] === el && i > 0) {
				el.setAttribute('data-stagger', i);
				break;
			}
		}
	}

	function init() {
		var elements = document.querySelectorAll(ALL_SELECTORS);

		var observer = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					assignStagger(entry.target);
					entry.target.setAttribute('data-revealed', '');
					observer.unobserve(entry.target);
				}
			});
		}, { threshold: THRESHOLD, rootMargin: ROOT_MARGIN });

		elements.forEach(function (el) {
			/* Skip above-fold elements AND elements with CSS @keyframes */
			if (isAboveFold(el) || hasCSSkeyframes(el)) {
				return;
			}
			el.classList.add('c87-reveal');
			observer.observe(el);
		});

		/* Safety net: reveal anything still hidden after 4s */
		setTimeout(function () {
			document.querySelectorAll('.c87-reveal:not([data-revealed])').forEach(function (el) {
				el.setAttribute('data-revealed', '');
			});
		}, 4000);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
